module.exports = __webpack_public_path__ + "static/media/export_icon.dd8b62e7.svg";